import { render, staticRenderFns } from "./VRangeInputV2.vue?vue&type=template&id=183d89fc&scoped=true&"
import script from "./VRangeInputV2.vue?vue&type=script&lang=js&"
export * from "./VRangeInputV2.vue?vue&type=script&lang=js&"
import style0 from "./VRangeInputV2.vue?vue&type=style&index=0&id=183d89fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183d89fc",
  null
  
)

export default component.exports